import Template from '../../component/Template.js';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import useAuth from '../../component/useAuth.js';
import Select from 'react-select'; //04-03-2024-multiselect

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Api from '../../component/Api.js';
import { Link } from 'react-router-dom';
import React, { useRef } from "react";

import 'datatables.net';
import 'datatables.net-bs4/css/dataTables.bootstrap4.min.css';
import $ from 'jquery';
export default function SFAUserMappingLists() {

  const [admissionYears, setAdmissionYears] = useState([]);
  const [admissionYear, setAdmissionYear] = useState(null);

  const [flag, setflag] = useState(false);

  const [semester_id, setSemester] = useState("");


  const tableRef = useRef(null);


  {/*------------------------------------*/ }
  /* CUSTOM DATA TABLE BEGIN HERE */
  const [tableData, setTableCountData] = useState([]);
  const [tableSummeryData, setTableSummaryData] = useState([]);

  const [sortBy, setSortBy] = useState({ column: null, direction: 'asc' }); //sort
  const [searchQuery, setSearchQuery] = useState('');
  const [filteredAndSortedData, setfilteredAndSortedData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [total_count, setTotal] = useState(null);
  const [loading, setlodaing] = useState(false);
  const [getCollegeTeacherData, setCollegeTeacherData] = useState([]);


  /* CUSTOM DATA TABLE END HERE */


  const { http } = Api();
  const navigate = useNavigate();

  const isAuth = useAuth();
  if (isAuth === false) {
    navigate("/college/");
  }


  let cid = localStorage.getItem("collegeid");

  useEffect(() => {
    const fetchAdmissionYears = async () => {
      try {
        const response = await http.get('/College/getSFASideActiveAdmissionYear');
        const years = response.data.map((year) => ({
          id: year.id,
          value: year.admission_year,
          label: year.admission_year
        }));
        setAdmissionYears(years);
      } catch (error) {
        console.error("Error fetching admission years:", error);
        toast.error("Error fetching admission years:");
      }
    };
    fetchAdmissionYears()


  }, []);

  const handleAdmissionYearChange = (selectedOption) => {
    setSemester("");
    setTableSummaryData([]);
    setTableCountData([]);
    //setAdmissionYear(selectedOption.value);
    setAdmissionYear(selectedOption ? selectedOption.value : null);
    toast.info("Please select semester too");

  };


  useEffect(() => {
    const getDisciplineCourseMappingSummary = async () => {
      try {
        const response = await http.get(`/College/getDisciplineCourseMappingSummary`, {
          params: {
            limit: '500',
            college_id: cid,
            admissionyear: admissionYear,
            semester_id: semester_id
          }
        });
        if (response.data.status_code === 'ERR5') {
          setflag(true);
        }
        setTableCountData(response.data.disciplines);
        setTableSummaryData(response.data.summary);
        //toast.success("Data loaded successfully");

      }
      catch (error) {
        if (error.response.data.http_status === 401 && error.response.data.status_code == "ERR9") {
          toast.error("Invalid Token");
          setTimeout(() => {
            navigate("/college/");
          }, 5000);

        }
        else if (error.response.data.http_status === 429 && error.response.data.status_code == "ERR33") {
          toast.error(error.response.data.message);
        }
        else {
          toast.error("Something went wrong");
        }
      }
    };

    if (semester_id && admissionYear && cid) {
      getDisciplineCourseMappingSummary();
    }

  }, [semester_id, admissionYear, cid]);


  /* DATA TABLE  */

  const handleSearchInputChange = (event) => {
    setSearchQuery(event.target.value);
  };

  const handleSort = (column) => {
    const newSortBy = {
      column,
      direction: sortBy.column === column && sortBy.direction === 'asc' ? 'desc' : 'asc',
    };
    setSortBy(newSortBy);
  };

  useEffect(() => {
    const filteredAndSortedData = [...tableData].filter(tableDatas => {
      return (
        tableDatas.discipline_name.toLowerCase().includes(searchQuery.toLowerCase()) ||
        tableDatas.total_courses.toLowerCase().includes(searchQuery.toLowerCase()) ||
        tableDatas.mapped_courses.toLowerCase().includes(searchQuery.toLowerCase()) ||

        tableDatas.pending_courses.toString().toLowerCase().includes(searchQuery.toLowerCase()) ||
        tableDatas.approved_courses.toString().toLowerCase().includes(searchQuery.toLowerCase())

      );
    }).sort((a, b) => {
      if (sortBy.direction === 'asc') {
        return a[sortBy.column] > b[sortBy.column] ? 1 : -1;
      } else {
        return a[sortBy.column] < b[sortBy.column] ? 1 : -1;
      }
    });

    const itemsPerPage = 50;
    const startIndex = (currentPage - 1) * itemsPerPage;
    const paginatedData = filteredAndSortedData.slice(startIndex, startIndex + itemsPerPage);

    setfilteredAndSortedData(paginatedData);
    setTotalPages(Math.ceil(filteredAndSortedData.length / itemsPerPage));
    setTotal(filteredAndSortedData.length);

  }, [searchQuery, sortBy, tableData, currentPage]);

  const renderSortIcon = (columnName) => {
    if (sortBy.column === columnName) {
      return sortBy.direction === 'asc' ? <i className="fa fa-sort-up ml-1" aria-hidden="true"></i> : <i className="fa fa-sort-down ml-1" aria-hidden="true"></i>;
    }
    return <i className="fa fa-sort ml-1" aria-hidden="true"></i>; // Show disabled sort icon
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  /* DATA TABLE END */

  const handleViewDetails = async (admissionYear, semester_id, discipline_id) => {
    setlodaing(true); // assuming you meant `setLoading`

    http
      .get('/College/getCollegerTeacher', {
        params: {
          college_id: cid,
          admissionyear: admissionYear,
          semester_id: semester_id,
          discipline_id: discipline_id
        },
      })
      .then((response) => {
        setCollegeTeacherData(response.data);
      })
      .catch((error) => {
        const status = error.response?.data?.http_status;
        const message = error.response?.data?.message || "An error occurred";

        if (status === 500 || error.response?.data?.status_code === "ERR5") {

          toast.error("No seat names were found");
        } else if (status === 403 && error.response?.data?.status_code === "ERR37") {
          toast.error("Invalid Token");
          setTimeout(() => navigate("/college/"), 5000);
        } else {
          toast.error("Something went wrong");
        }
      })
      .finally(() => {
        setlodaing(false);
      });
  };

  const encodeYear = yearid => {
    return btoa(yearid);
  };

  const encodeSemID = semid => {
    return btoa(semid);
  };
  const encodeDiscID = discid => {
    return btoa(discid);
  };
  const encodeDiscType = disctype => {
    return btoa(disctype);
  };
  const encodeSingleFaculty = singlefaculty => {
    return btoa(singlefaculty);
  };

  const handleGeneratePDFNew = async (discipline_id, disciplineName, course_type) => {
    // setLoading(true);
    try {
      const response = await http.get('/College/pdf_download', {
        params: {
          college_id: cid,
          admissionyear: admissionYear,
          semester_id: semester_id,
          discipline_id: discipline_id,
          course_type: course_type
        },
        responseType: 'blob', // Expect binary response
      });

      if (response && response.data) {
        // Create a URL for the downloaded file
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;

        // Set the file name and download the PDF
        link.setAttribute(
          'download',
          `${localStorage.getItem('username')}_${disciplineName}_TeacherCOurseMapping.pdf`
        );
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        // setLoading(false);
        toast.success('PDF generated successfully');
      }
    } catch (error) {
      //console.log("error",error);
      // setLoading(false);
      if (error.response.data.http_status === 401 && error.response.data.status_code == "ERR9") {
        toast.error("Invalid Token");
        setTimeout(() => {
          navigate("/college/");
        }, 5000);

      }
      else if (error.response.data.http_status === 500 && error.response.data.status_code == "ERR47") {
        toast.error(error.response.data.message);
      }
      else {
        console.error('Error generating PDF:', error);
        toast.error('Error generating PDF');
      }
    }
  };


  const customStyles = {
    menu: (provided) => ({
      ...provided,
      maxHeight: '200px',
      overflowY: 'auto',
      textAlign: 'left', // added

    }),
    menuList: (provided) => ({
      ...provided,
      maxHeight: '180px',
      overflowY: 'auto',
      scrollbarWidth: 'thin',
      scrollbarColor: '#888 #f1f1f1',
      textAlign: 'left', // added

    }),

    multiValue: (provided) => ({
      ...provided,
      '&::-webkit-scrollbar': {
        width: '8px',
        textAlign: 'left', // added

      },
      '&::-webkit-scrollbar-track': {
        background: '#f1f1f1',
      },
      '&::-webkit-scrollbar-thumb': {
        background: '#888',
        borderRadius: '4px',
      },
      '&::-webkit-scrollbar-thumb:hover': {
        background: '#555',
      },
    }),
  };

  return (
    <>
      <ToastContainer />
      <Template>
        <div className="container-fluid">
          <div className="row">
            <div className="table-responsive">
              <div className="card">
                <div className="col-md-12">
                  <div className="card-header">
                    <div className="py-3 d-flex justify-content-between align-items-center">
                      <h5>Teacher - Course Mapping</h5>
                    </div>
                  </div>
                  <div className="card-body">
                    {/* <div className="table-responsive"> */}
                    <div className="card-body">
                      <div className="row justify-content-center">
                        <div className="col-md-12 mb-4">
                          <div className="row">
                            <div className="col-md-6">
                              <label>Admission Year <span className="errorclr">*</span></label>
                              <Select
                                maxMenuHeight={200}
                                menuPlacement="auto"
                                id="admyear"
                                name="admyear"
                                className="form"
                                styles={customStyles}
                                options={admissionYears}
                                onChange={handleAdmissionYearChange}
                                value={admissionYears.find(opt => opt.value === admissionYear) || null}

                              />
                            </div>

                            <div className="col-md-6">
                              <label>Semester <span className="errorclr">*</span></label>
                              <Select
                                maxMenuHeight={200}
                                menuPlacement="auto"
                                id="semester_id"
                                name="semester_id"
                                className="form"
                                styles={customStyles}
                                options={[
                                  { value: 1, label: '1' },
                                  { value: 2, label: '2' },
                                  { value: 3, label: '3' },
                                  { value: 4, label: '4' }
                                ]}
                                value={
                                  semester_id
                                    ? { value: semester_id, label: semester_id.toString() }
                                    : null
                                }
                                onChange={(option) => setSemester(option ? option.value : "")}
                                placeholder="Select Semester"
                                isDisabled={!admissionYear} // ✅ Disable until admission year is selected
                              />
                            </div>


                          </div>
                        </div>
                      </div>

                      <div className="table-responsive ovrflw" style={{ overflowX: 'auto' }}>
                        <div className="row justify-content-center">
                          <div className="col-md-10 stat-out-bod">

                            <table className="table-striped  table-bordered ex-table mb-10" ref={tableRef} id="dataTable" width="100%" style={{ textAlign: 'center', tableLayout: 'fixed' }}>
                              <thead>
                                <tr>
                                  <th>Total Disciplines</th>
                                  <th>Forwarded</th>
                                  <th>Mapping Pending</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td colSpan="" style={{ textAlign: "center", verticalAlign: "middle", width: '50%', }}>{tableSummeryData.total_displine ? tableSummeryData.total_displine : '0'}

                                  </td>
                                  <td colSpan="" style={{ textAlign: "center", verticalAlign: "middle", width: '50%', }}>{tableSummeryData.total_mapped_displine ? tableSummeryData.total_mapped_displine : '0'}

                                  </td>
                                  <td colSpan="" style={{ textAlign: "center", verticalAlign: "middle", width: '50%', }}>{tableSummeryData.pending_displine ? tableSummeryData.pending_displine : '0'}

                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                      <div className="table-responsive">
                        <div className='row'>

                          <div className='col-md-6 wdt' >
                            <p>
                              Showing {(currentPage - 1) * 50 + 1}{''}-
                              {Math.min((currentPage - 1) * 50 + 50, total_count)} of {total_count} entries
                            </p>
                          </div>
                          <div className='col-md-6 wdt' align='right'>
                            <input
                              type="text"
                              value={searchQuery}
                              onChange={handleSearchInputChange}
                              placeholder="Search..."
                              className='form-control'
                            /></div></div>
                        <div class="table-containerq" style={{ overflowX: 'unset' }}>

                          <table className="display dataTable table-striped table-bordered ex-v-table " ref={tableRef}>
                            <thead>
                              <tr className="bg-primary">

                                <th onClick={() => handleSort('course_id')} scope="col" data-label="APAAR Id" width="8%">Sl No &nbsp;
                                  {renderSortIcon('course_id')} </th>
                                <th onClick={() => handleSort('discipline_name')} scope="col" data-label="Discipline " width="">Department/Discipline &nbsp;
                                  {renderSortIcon('discipline_name')} </th>
                                <th onClick={() => handleSort('total_courses')} scope="col" data-label="Total Courses" width="">Total Courses &nbsp;
                                  {renderSortIcon('total_courses')} </th>
                                <th onClick={() => handleSort('mapped_courses')} scope="col" data-label="Mapped Courses" width="">Mapped Courses &nbsp;
                                  {renderSortIcon('mapped_courses')} </th>
                                <th onClick={() => handleSort('pending_courses')} scope="col" data-label="Pending Courses" width="" > Mapping Pending Courses &nbsp;
                                  {renderSortIcon('pending_courses')} </th>
                                <th onClick={() => handleSort('approved_courses')} scope="col" data-label="Approved Courses" width="" > Approved Courses &nbsp;
                                  {renderSortIcon('approved_courses')} </th>

                                <th scope="col" data-label="Action" width="">Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              {filteredAndSortedData.length > 0 ? (
                                filteredAndSortedData.map((item, index) => {

                                  const serialNumber = (currentPage - 1) * 50 + index + 1;

                                  return (
                                    <tr key={`${item.discipline_id}-${item.course_type}`}>
                                      <td data-label="Sl No.">{serialNumber}</td>
                                      <td data-label="Discipline Name">{item.discipline_name}{item.scheme_id === 4 ? '(B.Voc)' : ''} {item.singlefaculty === 0 ? ' - Single Faculty Course' : ''} </td>
                                      <td data-label="Total Courses">{item.total_courses}</td>
                                      <td data-label="Mapped Courses">{item.mapped_courses}</td>
                                      <td data-label="Pending Courses" style={{ textAlign: 'center' }}>{item.pending_courses}</td>
                                      <td data-label="Approved Courses" style={{ textAlign: 'center' }}>{item.approved_courses}</td>

                                      <td data-label="View">
                                        <div className="txt-aln" style={{ cursor: 'pointer' }}>

                                          <Link to={`/college/sfausermappingdetails/${encodeYear(admissionYear)}/${encodeSemID(semester_id)}/${encodeDiscID(item.discipline_id)}/${encodeDiscType(item.course_type)}/${encodeSingleFaculty(item.singlefaculty)}`} title="View" target="_blank">

                                            <i className="bi bi-eye icn-out-bod icn-out-bod-hv" style={{ cursor: "pointer" }} title="View" />
                                          </Link>


                                          <i className="bi bi-download icn-out-bod icn-out-bod-hv m-l-5" title="Download" onClick={() => handleGeneratePDFNew(item.discipline_id, item.discipline_name, item.course_type)} />

                                        </div>


                                      </td>
                                    </tr>
                                  );
                                })
                              ) : (

                                <tr>
                                  <td colSpan="6" className="text-center">No data found</td>
                                </tr>
                              )}

                            </tbody>
                          </table>
                        </div>

                        {totalPages > 1 && (
                          <nav aria-label="..." style={{ cursor: "pointer" }}>
                            <ul className="pagination justify-content-center">
                              <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                <span className="page-link pgn-clr" onClick={handlePreviousPage}><i class="bi bi-arrow-left-circle-fill"></i></span>
                              </li>
                              <li className={`page-item`}>
                                <span className="page-link pgn-clr" onClick={() => handlePageChange(1)}>1</span>
                              </li>
                              {currentPage > 4 && <li className="page-item"><span className="page-link pgn-clr">...</span></li>}
                              {[...Array(totalPages - 1).keys()].slice(currentPage > 4 ? currentPage - 3 : 1, currentPage + 2).map((pageNumber) => (
                                <li key={pageNumber} className={`page-item ${pageNumber + 1 === currentPage ? 'act-clr' : ''}`}>
                                  <span className="page-link pgn-clr" onClick={() => handlePageChange(pageNumber + 1)}>{pageNumber + 1}</span>
                                </li>
                              ))}
                              {currentPage < totalPages - 3 && <li className="page-item"><span className="page-link pgn-clr">...</span></li>}

                              <li className={`page-item`}>
                                <span className="page-link pgn-clr" onClick={() => handlePageChange(totalPages)}>{totalPages}</span>
                              </li>

                              <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                                <span className="page-link pgn-clr" onClick={handleNextPage}><i class="bi bi-arrow-right-circle-fill"></i></span>
                              </li>
                            </ul>
                          </nav>
                        )}

                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Template>
    </>
  );
}
